import { getDate } from '../../utils/getDate'
import { isSummaryPrice } from './rules'

const SEPARATOR = ' · '

const CLINIC_MAX_LENGTH = 60

// `new Date(null)` devolve 1970-01-01, e `getDate` lança RangeError com data inválida.
const isValidExamDate = (date) => Boolean(date) && !Number.isNaN(new Date(date).getTime())

const displayClinic = (clinic) => {
  if (typeof clinic !== 'string' || clinic.trim() === '') return null

  return clinic.length > CLINIC_MAX_LENGTH ? `${clinic.slice(0, CLINIC_MAX_LENGTH)}…` : clinic
}

export const buildSummary = (exam, t) => {
  if (!exam) return { contextLine: null, price: null }

  const price = isSummaryPrice(exam?.payment?.price) ? exam.payment.price : null

  const examLine = isValidExamDate(exam?.date)
    ? t('payment.summaryExamLine', { date: getDate(exam.date) })
    : null

  const parts = [examLine, displayClinic(exam?.organizationDescription)].filter(Boolean)

  return { contextLine: parts.length > 0 ? parts.join(SEPARATOR) : null, price }
}
